export default __webpack_public_path__ + "static/media/94_desktop.d91595ba.jpg";